"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./domElements");
const initEvents_1 = require("./initEvents");
(0, initEvents_1.initEvents)();
